class ProductCarouselWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("tab-component:tab-selected", (e) => {
      console.log(`e.detail`, e.detail);
      this.querySelectorAll("[data-show-for]").forEach((el) => {
        el.style.display =
          el.dataset.showFor === e.detail.tab.id ? null : "none";
      });
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("product-carousel-wrapper")) {
  customElements.define("product-carousel-wrapper", ProductCarouselWrapper);
}
